
import { CreatePackageForm } from "@/components/package/CreatePackageForm";

interface EditPackageContentProps {
  packageData: {
    id: string;
    title: string;
    description: string;
    visibility: "public" | "subscription";
    price: number;
    recipes: string[];
  };
}

export const EditPackageContent = ({ packageData }: EditPackageContentProps) => {
  return (
    <>
      <h1 className="text-3xl font-bold mb-8">Edit Package</h1>
      <CreatePackageForm initialData={packageData} />
    </>
  );
};
